import axios from '@/request';
import qs from 'qs';

export default {
  async list(params: any) {
    return axios.get('operationlogs/list', { params });
  },
  async detail(params: any) {
    return axios.get('operationlogs/detail', { params });
  },
  async history(params: any) {
    return axios.get('operationlogs/history', { params });
  }
};
